import angular, { version } from 'angular';
import URLS from 'Helpers/urls';
import moment from 'moment';

(function() {
    'use strict';

    angular.module('app').component('apply3', {
        template: require('./apply3.html'),
        controller: ApplyCtrl,
        controllerAs: 'vm'
    });

    ApplyCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'Upload'
    ];

    function ApplyCtrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        Upload
    ) {
        var vm = this;
        vm.isPassword = false;
        vm.brand = require('Images/logo.png');
        vm.logo = require('Images/nav-logo.png');
        vm.mainBackground = require('Images/bunny.png');
        vm.hiring_process = require('Images/HIRING-PROCESS.png');
        vm.tap_image = require('Images/TAP-IMAGE.png');
        vm.qimage = require('Images/7.png');
        vm.requirements_image = require('Images/requirements2.png');
        vm.joinourteam = require('Images/joinourteam.png');
        vm.requirements_image2 = require('Images/requirements.png');
        vm.perks_image = require('Images/perks.png');

        vm.carousel_page = parseInt(Math.random() * 2);
        vm.carousel_page = 1
        carousel_change();
        function carousel_change(){
            setTimeout(()=>{
                if(vm.carousel_page == 0){
                    vm.carousel_page = 1;
                }else{
                    vm.carousel_page = 0;
                }
                $scope.$apply();
                carousel_change();
            }, 12000);
        }

        // The header text on top most of the page

        vm.carousel_images = [
            require('Images/carousel/2.png'),
            // require('Images/carousel/4.png'),
            // require('Images/carousel/6.png'),
        ];

        vm.perk_image1 = require('Images/perks/1.png');
        vm.perk_image2 = require('Images/perks/2.png');
        vm.perk_image3 = require('Images/perks/3.png');
        vm.perk_image4 = require('Images/perks/4.png');


        vm.carousel_index = parseInt(vm.carousel_images.length*Math.random());

        function start_carousel(){
            vm.carousel_index++;
            vm.carousel_index = (vm.carousel_index) % vm.carousel_images.length;
            setTimeout(()=>{
                $scope.$apply();
                start_carousel()
            }, 8000);
        }
        start_carousel();

        vm.tabs = [
            'Application Portal',
            'FAQs'
        ];
        vm.goTop = ()=>{
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
            });
        }
        
        vm.goBottom = ()=>{
            window.scroll({
                top: 10000, 
                left: 0, 
                behavior: 'smooth'
            });
        }
        
        setTimeout(()=>{
            vm.goTop();
        }, 200);

        window.onload = ()=> { vm.goTop() }

        vm.tab = vm.tabs[0];

        if($stateParams.state === 'faqs'){
            vm.tab = vm.tabs[1];
        }

        // apply_now();
        vm.apply_now = apply_now;
        vm.page = -1;
        vm.years_of_experience = [
            'No experience',
            'Less than a year',
            '1 - 2 years',
            '3 - 5 years',
            '5 years or more'
        ];

        vm.availability = [
            '3-6 hours per day ',
            '8 hours or more per day (I can teach morning and evening classes) ',
            '6 hours per day (peak hours - strictly 6PM to 12 MN)',
            'Others',
        ];

        vm.tags = [
            'OPIc',
            'TOEFL',
            'TOEIC',
            'Business English',
            'English for Traveling',
            'English for Kids',
            'Freetalking',
            'IELTS',
            'Job Interview Training'
        ].map(s => { return { text: s} });

        vm.data = {};
        check_now()
        vm.can_apply = 1;
        vm.can_apply = 0;
        function check_now(){

            // var request = {
            //     method: 'GET',
            //     params: false,
            //     hasFile: false,
            //     route: { settings_application_dates: 'now' }
            // };

            // QueryService.query(request)
            //     .then(
            //         function(response) {
            //             const d = response.data.data.items;
            //             // vm.can_apply = d.length != 0;
            //             vm.dates = d[0];
            //             console.log(vm.dates);
            //             init_processes();
            //         },
            //         function(error) {
            //         }
            //     )
            //     .finally(function() {
            //         vm.loaded_now = true;
            //     });
            
            var request = {
                method: 'GET',
                params: false,
                hasFile: false,
                route: { settings: 'hiring' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        if(parseInt(data.setting_data)){
                            vm.can_apply = true;
                        }
                        // console.log(data);
                        init_processes();
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });
        }
        check_location()
        function check_location(){
            var request = {
                method: 'GET',
                params: false,
                hasFile: false,
                route: { location: ''}
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        if(data.country != 'PH') vm.can_apply = 0;
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });

        }

        // apply_now();
        function apply_now(){
            
            var modal = {
                title: '',
                titleHeader: ''
            };

            ModalService.form_modal('', modal, 'applyModal3').then(function(response) {}, function(error) {});

        }

        vm.perks = [{
            svg: 'https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/svg/perks_1.png',
            name: 'Training and Development',
            desc: [
                'Free training and seminar on core ESL freelancing skills',
                'Regular profile evaluation with feedback for the improvement of teacher\'s capability to engage students.'
            ]
        }, {
            svg: 'https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/svg/perks_2.png',
            name: 'Competitive Salary Rates',
            desc: [
                'Starting rate of approximately 3.43 USD/hour',
                'Promotion with salary increase within an average of 30 days',
                'With monthly performance bonuses'
            ]
        }, {
            svg: 'https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/svg/perks_3.png',
            name: 'Semi-flexible Schedule',
            desc: [
                'Choose to work at your most convenient time between 5 am to 1 am PHT',
                'Students will have a regular schedule with you for at least four weeks.'
            ]
        }];
        
        vm.perks.forEach(e => { vm.perks.push(e) });

        vm.requirements = [{
            svg: 'https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/svg/requirement_1.svg',
            name: 'Employee Requirements',
            desc: ['Payoneer account','1 Valid Government ID']
        },{
            svg: 'https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/svg/requirement_2.svg',
            name: 'Technical Requirements',
            desc: [
                'Headset with a working microphone and noise cancellation',
                'At least 5 MBPS Internet connection',
                'A computer with 4GB RAM and Core 2 Duo Processor or higher',
                'Updated Google Chrome Application on Desktop',
                'Updated Kakao Talk Application on Desktop'
            ]
        }, {
            svg: 'https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/svg/requirement_3.svg',
            name: 'Teaching Requirements',
            desc: [
                'American/British/Australian/ Neutral Accent',
                'Ability to learn and teach multiple English subjects',
                'Can teach for at least 20 hours a week',
                'Ability to engage students in a meaningful conversation',
                'Ability and confidence to explain basic concepts of grammar, vocabulary, and conversational phrases'
            ]
        }];

        vm.format = (d, f) =>{
            return moment(d).format(f);
        }

        vm.login = () =>{
            // console.log('asdas');
            $state.go('login2', {});
        }
        
        function get_date(date){
            return moment((vm.dates || {})[date]).format('MMM DD, YYYY');
        }

        function init_processes(){

            vm.processes = [{
                name: 'Answer a short quiz',
                desc: `Applicants who will get 80% of the answers correctly shall proceed to the next part of the application`
            },{
                name: 'Register and download our application portal app',
                desc: `After registering, you will be asked to download our application portal app`
            },{
                name: 'Submit your application via our application portal',
                desc: `A hollistic skill based screening approach, our application portal measures a teacher's ability to convey knowledge to students and preparedness for online ESL teaching. We are accepting applications from ${ get_date('start') } to ${ get_date('end') }. `
            },{
                name: 'Receive an update via e-mail',
                desc: `Applicants will be screened based on ther submissions and the screening will start on ${ get_date('end') } and end on ${ get_date('screening')}. \nWe will start sending e-mails about the result on ${ get_date('emails') }`
            },{
                name: 'Online Interview',
                desc: `The interview consist of a mock class and an audio interview. The duration of the interview will be 20-30 minutes.`
            },{
                name: 'Preliminary Contract Signing',
                desc: 'Other employee perks and responsibilities will be discussed here.'
            },{
                name: 'Paid Training and Onboarding',
                desc: 'Have a 1 on 1 training with a coach on company rules and operational processes.'
            },{
                name: 'Signing of Official Contract and Start of Teaching',
                desc: ''
            }];
            
            vm.processes.forEach((p, i)=>{
                p.svg = 'https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/svg/process_' + (i+1) + '.svg'
            });
    
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/apply3/apply3.component.js